import { render, staticRenderFns } from "./ChannelMmpOfferList.vue?vue&type=template&id=2347cd75&scoped=true"
import script from "./ChannelMmpOfferList.vue?vue&type=script&lang=js"
export * from "./ChannelMmpOfferList.vue?vue&type=script&lang=js"
import style0 from "./ChannelMmpOfferList.vue?vue&type=style&index=0&id=2347cd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2347cd75",
  null
  
)

export default component.exports